import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { getErrorMessage } from "../functions";


type InputProps = { 
    id?: string;
    // invalid?: boolean | null;
    error?: any;
    label?: string;
    type?: string;
    name?: string;
    placeholder?: string;
    disabled?: boolean | null;
    required?: boolean | null;
    value?: string | null;
    autoComplete?: string;
    className?: string;
    onChange?: any;
    defaultValue?: string | number | null;
};

const StyledInput = styled.textarea<InputProps>`
  ${tw`block mb-1 font-semibold text-gray-600`}
  ${tw` px-3 py-2 border-gray-400 rounded-md border `}
  ${(props) => props.type !== 'checkbox' ? tw`max-w-full w-full` : tw`w-6 h-6`}
  ${(props) => props.error ? tw`border-red-500` : ``}
`;



const Input = React.forwardRef<HTMLTextAreaElement, InputProps>(({ error, label, ...rest }: InputProps, ref) => (
    <>
        {label && (<label className={`block text-sm font-medium text-gray-700`}>{label}{rest.required && (<span className="text-red-700 font-bold "> *</span>)}  </label>)}
        <StyledInput
            // className={`max-w-full w-full px-3 py-1 border-gray-400 rounded-md border ${props.error && 'border-red-500'}`}
            ref={ref}
            {...rest}
        />
        {error && (
            <div className={`flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1 mb-2`}>{getErrorMessage(error)}</div>
        )}
    </>
)
);

export default Input;

